"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _tooltip = _interopRequireDefault(require("./tooltip.scss"));

var _classnames = _interopRequireDefault(require("classnames"));

var Tooltip = function Tooltip(_ref) {
  var value = _ref.value,
      classNames = _ref.classNames;
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_tooltip["default"].Tooltip, classNames.wrapper)
  }, _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_tooltip["default"].icon, classNames.icon)
  }), _react["default"].createElement("div", {
    className: (0, _classnames["default"])(_tooltip["default"].content, classNames.content)
  }, _react["default"].createElement("div", null, value)));
};

Tooltip.propTypes = {
  value: _propTypes["default"].string,
  classNames: _propTypes["default"].object
};
Tooltip.defaultProps = {
  classNames: {}
};
var _default = Tooltip;
exports["default"] = _default;